import { createBrowserHistory, createHashHistory } from 'history';
let history = createBrowserHistory();
//let history = createHashHistory();
export default history;